module.exports = __webpack_public_path__ + "img/recruit_step.3a5ab597.png";